import { StatusUIType } from 'sections/LKSection/shared/components/UI/Status/Status'
import { PHOTO_FORMATS, VIDEO_FORMATS } from 'shared/constants/values'

import { TicketReason, TicketStatus, TicketType } from './types'

export const MIN_DESCRIPTION_LENGTH = 20

export const initialTicketFileValue = { content: '', fileSize: 0, format: '', name: '' }

export const enum TicketKeys {
  ticketModule = 'ticketModule',
  ticketPage = 'ticketModule.ticketPage',
  ticketItemPage = 'ticketModule.ticketItemPage',
  createTicket = 'ticketModule.createTicket',
}

export const ticketTypeLabels = {
  [TicketType.openingOrder]: 'Заявка по открытию ПВЗ',
  [TicketType.roomLayout]: 'Планировка помещения',
}

export const ticketReasonLabels = {
  [TicketReason.eLock]: 'Вопрос по электронному замку в подарок',
  [TicketReason.signboard]: 'Вопрос по вывеске/кронштейну в подарок',
}

export const ticketTypeOptions = [
  { value: TicketType.openingOrder, label: ticketTypeLabels[TicketType.openingOrder] },
  { value: TicketType.roomLayout, label: ticketTypeLabels[TicketType.roomLayout] },
]

export const ticketReasonOptions = [
  { value: TicketReason.eLock, label: ticketReasonLabels[TicketReason.eLock] },
  { value: TicketReason.signboard, label: ticketReasonLabels[TicketReason.signboard] },
]

export const ticketStatusTranslator: Record<TicketStatus, { title: string; type: StatusUIType }> = {
  [TicketStatus.open]: {
    title: 'Новый',
    type: StatusUIType.corp,
  },
  [TicketStatus.inProgress]: {
    title: 'В работе',
    type: StatusUIType.gray,
  },
  [TicketStatus.closed]: {
    title: 'Решён',
    type: StatusUIType.green,
  },
}

export const ticketStatusOptions = [
  { value: TicketStatus.open, label: ticketStatusTranslator[TicketStatus.open].title },
  { value: TicketStatus.inProgress, label: ticketStatusTranslator[TicketStatus.inProgress].title },
  { value: TicketStatus.closed, label: ticketStatusTranslator[TicketStatus.closed].title },
]

export const ticketPhotoValidate = { allowedFileFormats: PHOTO_FORMATS, maxFileSizeMb: 10 }
export const ticketFileValidate = { allowedFileFormats: [...PHOTO_FORMATS, ...VIDEO_FORMATS], maxFileSizeMb: 10 }

export const ticketGradeTranslator = {
  1: 'Очень плохо',
  2: 'Плохо',
  3: 'Нормально',
  4: 'Хорошо',
  5: 'Отлично',
}
